// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3O7k8","row":"ProcedureTreatmentSummary_row__2U8Vb"};